import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'itemCategory';

const itemCategoryService = {
  getData: (data) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/data`,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};
export default itemCategoryService;
